/**
 * CR V3 统一 Join 落地页路由（匿名，无布局）
 */

import type { RouteRecordRaw } from 'vue-router'

export const crV3JoinRoute: RouteRecordRaw = {
  path: '/cr-v3/join/:code',
  name: 'CrV3Join',
  component: () => import('@/modules/cr-v3-viewer/views/CrV3JoinGateView.vue'),
  props: true,
  meta: {
    title: '加入会议',
    requiresAuth: false,
    hidden: true,
  },
}

export default crV3JoinRoute
